// Mobile menu and the "Custom Labels" dropdown (replaces Bootstrap's collapse and dropdown plugins)

/**
 * <button data-disclosure aria-controls="id" aria-expanded="false"> shows and hides
 * the element with that id (via the hidden attribute) and gets .is-active while open.
 */
export function initDisclosures() {
  for (const button of document.querySelectorAll("[data-disclosure]")) {
    const target = document.getElementById(button.getAttribute("aria-controls"));
    if (!target) continue;
    button.addEventListener("click", () => {
      const open = button.getAttribute("aria-expanded") !== "true";
      button.setAttribute("aria-expanded", String(open));
      button.classList.toggle("is-active", open);
      target.hidden = !open;
    });
  }
}

/**
 * <button data-dropdown aria-controls="id" aria-expanded="false"> toggles a menu panel.
 * Closes on Escape (returning focus to the button) and on clicks outside the menu.
 */
export function initDropdowns() {
  for (const button of document.querySelectorAll("[data-dropdown]")) {
    const menu = document.getElementById(button.getAttribute("aria-controls"));
    if (!menu) continue;

    const setOpen = (open) => {
      button.setAttribute("aria-expanded", String(open));
      menu.hidden = !open;
    };

    button.addEventListener("click", () => setOpen(menu.hidden));
    document.addEventListener("click", (event) => {
      if (!menu.hidden && !button.contains(event.target) && !menu.contains(event.target)) {
        setOpen(false);
      }
    });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && !menu.hidden) {
        setOpen(false);
        button.focus();
      }
    });
  }
}
